import $ from 'jquery';
import { LocationApi } from '../api/apicollection';
import { formatAddress, formatPhoneNumber } from '../util/formatHelper';

export default function EmbeddedMapViewModel() {
    let map, directionsManager, location;

    this.loadMap = () => {
        let navigationBarMode = Microsoft.Maps.NavigationBarMode;

        map = new Microsoft.Maps.Map(document.getElementById('myMap'), {
            navigationBarMode: navigationBarMode,
            showMapTypeSelector: false,
            showScalebar: false,
            mapTypeId: Microsoft.Maps.MapTypeId.road,
            disableScrollWheelZoom: true,
            disableTouchInput: true,
            showLocateMeButton: false,
            zoom: 15
        });



        Microsoft.Maps.loadModule('Microsoft.Maps.Search', function () {
            let searchManager = new Microsoft.Maps.Search.SearchManager(map);
            let requestOptions = {
                bounds: map.getBounds(),
                where: location.address,
                callback: function (answer, userData) {
                    map.setView({ bounds: answer.results[0].bestView });
                    map.entities.push(new Microsoft.Maps.Pushpin(answer.results[0].location, { title: location.name }));
                }
            };
            searchManager.geocode(requestOptions);
        });

        Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', function () {
            var options = {
                maxResults: 4,
                map: map
            };
            var manager = new Microsoft.Maps.AutosuggestManager(options);
            manager.attachAutosuggest('#searchBox', '#searchBoxContainer');
        });

    }

    this.getDirections = () => {
        setDirections();
    }

    function setDirections() {
        if (!directionsManager) {
            Microsoft.Maps.loadModule('Microsoft.Maps.Directions',
                function () {
                    directionsManager = new Microsoft.Maps.Directions.DirectionsManager(map);
                    setDirections();
                });
        } else {
            let toAddress = document.getElementById('searchBox').value;
            // Set Route Mode to driving
            directionsManager.setRequestOptions({ routeMode: Microsoft.Maps.Directions.RouteMode.driving });
            let waypoint1 = new Microsoft.Maps.Directions.Waypoint({ address: toAddress });
            let waypoint2 = new Microsoft.Maps.Directions.Waypoint({ address: location.address });

            //Clear any previous routes.
            directionsManager.clearAll();

            directionsManager.addWaypoint(waypoint1);
            directionsManager.addWaypoint(waypoint2);

            // Set the element in which the itinerary will be rendered
            directionsManager.setRenderOptions({ itineraryContainer: document.getElementById('directions'), displayManeuverIcons: false});
            directionsManager.calculateDirections();
        }
    }

    this.Load = () => {
        $('#loadingSpinner').hide();
        LocationApi.getLocationData().then(data => {
            let newData = data.data;
            let physicalAddress = newData.addresses.find(addr => addr.addressType === 'Work');
            let workPhone = newData.phoneNumbers.filter(p => p.phoneNumberTypeID === 'Work');

            location = {
                name: newData.name,
                address: formatAddress(physicalAddress),
                lat: newData.latitude,
                long: newData.longitude,
                phone: formatPhoneNumber(workPhone[0].thePhoneNumber)
            }
            window.onload = this.loadMap();
        });

    };
    this.Load()
    return this;
};

